import { Injectable } from '@angular/core';

export interface ColumnSpec {
  columnName: string;
  label: string;
  tooltipKey: string; // clave i18n, p.ej. 'DATATABLE.COLUMN.CREATED_AT.TOOLTIP'
  nowrap?: boolean; // por defecto true (tooltips cortos de cabecera). false para textos largos que deben envolverse.
}

@Injectable({
  providedIn: 'root'
})
export class ColumnSpecsService {

  private specs: { [key: string]: ColumnSpec } = {

    // ========== DATATABLE COLUMNS ==========
    'created_at': {
      columnName: 'created_at',
      label: 'DATATABLE.COLUMN.CREATED_AT',
      tooltipKey: 'DATATABLE.COLUMN.CREATED_AT_TOOLTIP',
    },
    'created_at_non_utc': {
      columnName: 'created_at_non_utc',
      label: 'DATATABLE.COLUMN.CREATED_AT_NON_UTC',
      tooltipKey: 'DATATABLE.COLUMN.CREATED_AT_NON_UTC_TOOLTIP',
    },
    'date': {
      columnName: 'date',
      label: 'DATATABLE.COLUMN.DATE',
      tooltipKey: 'DATATABLE.COLUMN.DATE_TOOLTIP',
    },

    // ========== BULK ENTITY/USER CREATION FIELDS ==========
    'bulkParentEntity': {
      columnName: 'bulkParentEntity',
      label: 'ADMIN.BULK.PARENT_ENTITY',
      tooltipKey: 'ADMIN.BULK.PARENT_ENTITY_TOOLTIP',
      nowrap: false,
    },
    'bulkCsvFile': {
      columnName: 'bulkCsvFile',
      label: 'ADMIN.BULK.CSV_FILE',
      tooltipKey: 'ADMIN.BULK.CSV_FILE_TOOLTIP',
      nowrap: false,
    },
    'bulkCsvFileAll': {
      columnName: 'bulkCsvFileAll',
      label: 'ADMIN.BULK.CSV_FILE_ALL',
      tooltipKey: 'ADMIN.BULK.CSV_FILE_ALL_TOOLTIP',
      nowrap: false,
    },
    'bulkCsvFileUsers': {
      columnName: 'bulkCsvFileUsers',
      label: 'ADMIN.BULK.CSV_FILE_USERS',
      tooltipKey: 'ADMIN.BULK.CSV_FILE_USERS_TOOLTIP',
      nowrap: false,
    },
    'bulkPackageTypeId': {
      columnName: 'bulkPackageTypeId',
      label: 'ADMIN.BULK.PACKAGE_TYPE',
      tooltipKey: 'ADMIN.BULK.PACKAGE_TYPE_TOOLTIP',
      nowrap: false,
    },
    'bulkPackageCategoryId': {
      columnName: 'bulkPackageCategoryId',
      label: 'ADMIN.BULK.PACKAGE_CATEGORY',
      tooltipKey: 'ADMIN.BULK.PACKAGE_CATEGORY_TOOLTIP',
      nowrap: false,
    },
    'bulkPackagePeriodId': {
      columnName: 'bulkPackagePeriodId',
      label: 'ADMIN.BULK.PACKAGE_PERIOD',
      tooltipKey: 'ADMIN.BULK.PACKAGE_PERIOD_TOOLTIP',
      nowrap: false,
    },
    'bulkTestDays': {
      columnName: 'bulkTestDays',
      label: 'ADMIN.BULK.TEST_DAYS',
      tooltipKey: 'ADMIN.BULK.TEST_DAYS_TOOLTIP',
      nowrap: false,
    },
    'bulkDownloadCredentialsCsv': {
      columnName: 'bulkDownloadCredentialsCsv',
      label: 'ADMIN.BULK.DOWNLOAD_CREDENTIALS_CSV',
      tooltipKey: 'ADMIN.BULK.DOWNLOAD_CREDENTIALS_CSV_TOOLTIP',
      nowrap: false,
    },

  };

  getSpec(columnName: string): ColumnSpec | undefined {
    return this.specs[columnName];
  }

  hasSpec(columnName: string): boolean {
    return !!this.specs[columnName];
  }

}
